
function TicketNotes({ticketId, notes, addTicketNote, status}){
    return (
        <div>TicketNotes</div>
    )
}
export default TicketNotes
